
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind10 as ObiWind10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-10.js';
 
 
 

 
 export const ObiWind10 = createComponent({
   react: React,
   tagName: 'obi-wind-10',
   elementClass: ObiWind10Element,
   events: {
     
   }
  });
 
 